export const escapeCsvValue = (value: unknown): string => {
    if (value === null) {
        return '';
    }
    let str = String(value);

    // If value contains special characters, wrap in quotes and escape quotes
    if (/[",\n]/.test(str)) {
        str = `"${str.replace(/"/g, '""')}"`;
    }

    return str;
};

export const download = (
    blob: Blob,
    fileName: string,
    extension: string,
): void => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}${extension}`);

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
